import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDLhzkc0vYksbojxkrPh9188Hw7kURL9to",
  authDomain: "aghorimatka-2697d.firebaseapp.com",
  projectId: "aghorimatka-2697d",
  storageBucket: "aghorimatka-2697d.firebasestorage.app",
  messagingSenderId: "743507339143",
  appId: "1:743507339143:web:e43e31af0574dd9eb11522",
  measurementId: "G-ZWWLEK1WW6",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// Request permission for notifications
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("Notification permission granted.");

      // Get FCM token
      const token = await getToken(messaging, {
        vapidKey: "BKr5u9F4FD1a4tqkcTuffJxYwq-ekxeElx60WdSbvr6ziuM-QO_o38pO1HZs1xANIwCEnqm6vggcKYHdlE9EXKs", // Your Firebase VAPID key
      });

      if (token) {
        console.log("FCM Token:", token);
        // Save the token to your database (e.g., to the user's profile)
        return token;
      } else {
        console.log("No FCM token available.");
      }
    } else {
      console.log("Notification permission denied.");
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
};

// Listen for incoming messages
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Message received:", payload);
      resolve(payload);
    });
  });
